// app.config.ts
import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// Import your services
import { NgbCustomDateAdapter, NgbCustomDateParserFormatter } from './core/datepicker/datepicker-adapter';
import { loaderSpinnerInterceptor } from './core/loader-spinner/loader-spinner-interceptor';
import { authenticationInterceptor } from './services/authentication/authentication-interceptor';
import { ConfigLoaderService } from './services/config-loader/config-loader-service';
import { httpRequestInterceptor } from './system/http-request-interceptor';

// Import your routes
import { routes } from './app.routes';
import { ReplaceTextPipe } from './pipes/replace-text.pipe';
import { LanguageService } from './core/i18n/language.service';


// App initializer factory
export function appInitializerFactory(configLoaderService: ConfigLoaderService) {
  return () => configLoaderService.loadConfig();
}

export const appConfig: ApplicationConfig = {
  providers: [
    // Router
    provideRouter(routes),
    
    // Animations
    provideAnimations(),
    
    // HTTP Client with interceptors
    provideHttpClient(
      withInterceptors([
        authenticationInterceptor,
        httpRequestInterceptor,
        loaderSpinnerInterceptor
      ])
    ),

    DatePipe,
    ReplaceTextPipe,
    // Translation configuration
    provideTranslateService({
      defaultLanguage: 'fr_CA',
      fallbackLang: 'fr_CA',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    }),
    
    
    // Services
    // DatePipe,
    // LoaderSpinnerService,
    // AuthenticationService,
    // MapSwitcherService,
    // MapRelocatorService,
    // ToastService,
    // AuthenticationGuard,
    // SubscriberAuthenticationGuard,
    // NoAuthenticationGuard,
    // LoginAuthenticationGuard,
    // ServiceBaseConfiguration,
    // ErrorHandlerService,
    // ConfigLoaderService,
    // GoogleTagsService,
    // ServiceBase,
    
    // App Initializer
    provideAppInitializer(() => {
      const configLoaderService = inject(ConfigLoaderService);
      return configLoaderService.loadConfig();
    }),
    
    // Language Service Initializer (runs after config loader)
    provideAppInitializer(() => {
      const languageService = inject(LanguageService);
      return languageService.init();
    }),
    
    // NgBootstrap Date Adapters
    { provide: NgbDateAdapter, useClass: NgbCustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: NgbCustomDateParserFormatter },
    
    
    // Note: SimpleNotificationsModule and NgbModule would need to be handled differently
    // You might need to import their providers or use them in individual components
  ]
};
